import { useTranslation } from "react-i18next"

function LegendDot({ color }: { color: string }) {
  return (
    <span
      className="inline-block h-2.5 w-2.5 rounded-full border border-white shadow-sm"
      style={{ backgroundColor: color }}
    />
  )
}

/** Corner overlay legend for the detail map's markers. */
export function FuelMapLegend({ showSeen }: { showSeen: boolean }) {
  const { t } = useTranslation()
  return (
    <div className="absolute bottom-2 left-2 z-10 flex flex-col gap-1 rounded-md border bg-background/90 p-2 text-[11px] leading-4 shadow">
      <span className="inline-flex items-center gap-1.5">
        <LegendDot color="#14ae5c" /> {t("reports.fuelMapLegend.suggested")}
      </span>
      <span className="inline-flex items-center gap-1.5">
        <LegendDot color="#2563eb" /> {t("reports.fuelMapLegend.driverAtSend")}
      </span>
      <span className="inline-flex items-center gap-1.5">
        <LegendDot color="#f59e0b" /> {t("reports.fuelMapLegend.refuelPoint")}
      </span>
      {showSeen && (
        <span className="inline-flex items-center gap-1.5">
          <LegendDot color="#7c3aed" /> {t("reports.fuelMapLegend.seenHere")}
        </span>
      )}
    </div>
  )
}
